/* Copyright 2013 - 2024 Waiterio LLC */
const colorSecondary = '#6874E8'

export default colorSecondary
